import { ActionTableState } from "../../action-table/action-table";
import AssignmentTable from "../../fragments/assignment-table";


function EmployeeAssignmentList({ employeeId }) {
  return <div style={{ height: '100%', overflow: "auto"}}><AssignmentTable as={ActionTableState} preselectedEmployeeId={employeeId} /></div>
}

export default EmployeeAssignmentList;